import { makeStyles, Typography } from "@material-ui/core";
import React, { useContext } from "react";
import { SubscriptionContext } from "../subscriptionContext";
import { checkIfFinalized, getNextPayment, getStatus } from "../util";
import CardSection from "./Sections/CardSection";
import InfoSection from "./Sections/InfoSection";
import ChargesSection from "./Sections/ChargesSection";
import { useMediaQuery } from "@mantine/hooks";
import { Button } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  container: {
    "@media(max-width: 1024px)": {
      padding: "16px",
    },
  },
  pageInfo: {
    fontSize: "0.875rem",
    color: theme.app.secondaryColor,
    marginBottom: "2rem",
    marginTop: ".5rem",
  },
  detailsPageWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "25px",
  },
  upperSectionWrapper: {
    display: "flex",
    flexDirection: "row",
    "@media(max-width: 750px)": {
      flexDirection: "column",
      gap: "25px",
    },
  },
  back: {
    marginTop: "2rem",
    borderTop: `1px solid ${theme.app.borderColor}`,
    padding: "8px 0",
  },
}));

const SubscriptionDetailsPage = () => {
  const isMobile = useMediaQuery("(max-width: 667px)");

  const classes = useStyles();
  const { data, subscriptionId } = useContext(SubscriptionContext);

  if (!data) return null;

  const {
    subscriptionTypeName,
    updatePaymentCardUrl,
    state,
    charges,
    subscriptionTermType,
  } = data.subscriptionDetails;

  const status = getStatus(state);

  const paidCharges = charges.filter((charge) => charge.status === "Charged");
  const nextPayment = charges.length > 0 && getNextPayment(charges);

  const subscriptionIsFinalized =
    state !== "Registered" &&
    checkIfFinalized(subscriptionTermType, paidCharges, charges, nextPayment);

  const canUpdatePaymentCard =
    !subscriptionIsFinalized && paidCharges.length > 0;

  return (
    <div className={classes.container}>
      <Typography variant="h1">{subscriptionTypeName}</Typography>
      <Typography className={classes.pageInfo}>
        Här ser du info om ditt abonnemang
        {canUpdatePaymentCard && " och kan byta betalkort"}
      </Typography>

      <main className={classes.detailsPageWrapper}>
        <div className={classes.upperSectionWrapper}>
          <InfoSection
            paidCharges={paidCharges}
            nextPayment={nextPayment}
            data={data}
            status={status}
            subscriptionIsFinalized={subscriptionIsFinalized}
          />
          {status !== "Avbruten" && (
            <CardSection
              data={data}
              updatePaymentCardUrl={updatePaymentCardUrl}
              status={status}
              subscriptionId={subscriptionId}
              canUpdatePaymentCard={canUpdatePaymentCard}
            />
          )}
        </div>
        {charges.length > 0 && (
          <ChargesSection isMobile={isMobile} charges={charges} />
        )}
      </main>
      <div className={classes.back}>
        <Button
          className={classes.button}
          variant="subtle"
          color="dark"
          onClick={() => window.history.back()}
        >
          Tillbaka
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionDetailsPage;
